import { configureStore } from '@reduxjs/toolkit';
import './immerConfig';
import userReducer from './usersSlice';
import postsReducer from './postsSlice';
import categoriesReducer from './categoriesSlice';
import projectInfoReducer from './projectInfoSlice';
import toastReducer from "./toastSlice";

export const store = configureStore({
  reducer: {
    users: userReducer,
    posts: postsReducer,
    categories: categoriesReducer,
    projectInfo: projectInfoReducer,
    toast: toastReducer,
  }
});